import React from 'react';
import PropTypes from 'prop-types';

import { COLORS } from '../../constants';

const propTypes = {
  colorCode: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

const defaultProps = {
  colorCode: COLORS.BLACK,
  width: 18,
  height: 18,
};

const AvatarIcon = props => {
  const { colorCode, width, height } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M7 .233A6.765 6.765 0 0 0 2.567 12.11v-2.077a2.8 2.8 0 0 1 2.8-2.8h3.266a2.8 2.8 0 0 1 2.8 2.8v2.077A6.765 6.765 0 0 0 7 .233zM7 6.3a2.1 2.1 0 1 1 0-4.2 2.1 2.1 0 0 1 0 4.2z" />
        <path
          fill={colorCode}
          d="M9.1 4.2a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0zM8.633 7.233H5.367a2.8 2.8 0 0 0-2.8 2.8v2.077a6.76 6.76 0 0 0 8.866 0v-2.077a2.8 2.8 0 0 0-2.8-2.8z"
        />
        <path
          fill={colorCode}
          fillRule="nonzero"
          d="M7 0a7 7 0 1 0 1.208 13.894l.074-.013A7 7 0 0 0 7 0zm-.562 13.509H6.42a6.472 6.472 0 0 1-.54-.072l-.03-.005a6.507 6.507 0 0 1-.519-.115l-.041-.01a6.511 6.511 0 0 1-.495-.157l-.05-.017a6.41 6.41 0 0 1-.47-.195l-.058-.026c-.151-.07-.3-.15-.445-.232l-.061-.035a6.616 6.616 0 0 1-.42-.267l-.063-.043a6.562 6.562 0 0 1-.394-.304l-.035-.03v-1.968a2.57 2.57 0 0 1 2.567-2.566h3.266a2.57 2.57 0 0 1 2.567 2.566v1.968l-.031.026c-.13.109-.264.212-.402.309l-.055.037a6.524 6.524 0 0 1-.426.273l-.055.03a6.31 6.31 0 0 1-.978.455l-.046.017a6.56 6.56 0 0 1-.497.157l-.04.01a6.573 6.573 0 0 1-.52.116l-.03.004c-.178.032-.358.056-.54.072h-.016a6.542 6.542 0 0 1-1.126.002zm5.229-1.94v-1.536A3.037 3.037 0 0 0 8.633 7H5.367a3.037 3.037 0 0 0-3.034 3.033v1.535a6.533 6.533 0 1 1 9.334 0z"
        />
        <path
          fill={colorCode}
          fillRule="nonzero"
          d="M7 1.75a2.333 2.333 0 1 0 0 4.667A2.333 2.333 0 0 0 7 1.75zm0 4.083a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5z"
        />
      </g>
    </svg>
  );
};

AvatarIcon.propTypes = propTypes;
AvatarIcon.defaultProps = defaultProps;

export default AvatarIcon;
